import React from 'react';
import { Mail } from 'lucide-react';
export function Support() {
  return <section className="bg-white py-10 px-5 text-center" data-id="element-38">
      <div className="max-w-md mx-auto flex flex-col items-center gap-2" data-id="element-39">
        <p className="text-[16px] text-aurora-gray" data-id="element-40">
          Ficou com dúvida? Fala com a gente 👇
        </p>
        <a href="mailto:suporte@myaurora.com.br" className="inline-flex items-center gap-2 text-aurora-pink font-bold text-[16px] hover:underline" data-id="element-41">
          <Mail className="w-4 h-4" strokeWidth={2.4} data-id="element-42" />
          suporte@myaurora.com.br
        </a>
        <p className="text-[13px] text-aurora-gray-light mt-1" data-id="element-43">
          Respondemos em até 24 horas úteis.
        </p>
      </div>
    </section>;
}